import * as yup from 'yup';
import { DataTableHtmlFormatter } from '../../../../Component/Model/helpers';

const descriptionMaxLength: number = 1000;

export const feedbackSchema = yup.object({
    Feedback: yup.string()
        .required('Feedback is required')
        .test('feedbackLengthTest', `Feedback is too long`, value => {
            if (!value) {
                return true;
            }
            return DataTableHtmlFormatter(value, '').length <= descriptionMaxLength;
        })
})